import { getEventUserType, GTM_CLICK_EVENT, sendGTMCustomClickEvent, sendGTMEvent } from '../../../helpers/gtmHelper'
import { IMainMenu, MENU_HREF_LOCALE, MENU_HREF_TYPE } from '../interface/navigation.interface'

import { CurrentUser } from '../../../model/Common/common.interface'

import { CustomRouter } from '../../../modules/hooks/common/useAppRouter'
import { STUDENT_BTN_ID } from '../../../modules/ids/gtm/student'
import urls from '../../../modules/urls'

export const getMobileMenuList: (userId: number | undefined) => IMainMenu = (userId) => [
  {
    id: userId ? STUDENT_BTN_ID.CLICK_MENU_LOGOUT : STUDENT_BTN_ID.CLICK_MENU_LOGIN,
    label: userId ? '로그아웃' : '로그인',
    isEvent: false,
    href: {
      url: userId ? urls.oneOnOne.index : urls.student.auth.signIn,
      type: userId ? MENU_HREF_TYPE.LOGOUT : MENU_HREF_TYPE.WITHIN,
      locale: MENU_HREF_LOCALE.CURRENT,
    },
    subMenu: null,
  },
  {
    id: STUDENT_BTN_ID.CLICK_MENU_WHAT_IS_RINGLE,
    label: 'What is Ringle',
    isEvent: false,
    href: null,
    subMenu: [
      {
        subMenuSectionTitle: null,
        subMenuList: [
          {
            id: STUDENT_BTN_ID.CLICK_MENU_TUTOR,
            label: '튜터',
            href: {
              url: urls.oneOnOne.tutor,
              type: MENU_HREF_TYPE.WITHIN,
              locale: MENU_HREF_LOCALE.CURRENT,
            },
          },
          {
            id: STUDENT_BTN_ID.CLICK_MENU_MATERIALS,
            label: '교재',
            href: {
              url: urls.oneOnOne.material,
              type: MENU_HREF_TYPE.WITHIN,
              locale: MENU_HREF_LOCALE.CURRENT,
            },
          },
          {
            id: STUDENT_BTN_ID.CLICK_MENU_FEATURES,
            label: '수업 시스템',
            href: {
              url: urls.student.landing.system,
              type: MENU_HREF_TYPE.WITHIN,
              locale: MENU_HREF_LOCALE.CURRENT,
            },
          },
        ],
      },
    ],
  },
  {
    id: STUDENT_BTN_ID.CLICK_MENU_RINGLE_FOR,
    label: 'Ringle for',
    isEvent: false,
    href: null,
    subMenu: [
      {
        subMenuSectionTitle: 'BY CUSTOMERS',
        subMenuList: [
          {
            id: STUDENT_BTN_ID.CLICK_MENU_GLOBAL_PROFESSIONALS,
            label: '직장인/전문직',
            href: {
              url: urls.student.landing.case.customer.professional,
              type: MENU_HREF_TYPE.WITHIN,
              locale: MENU_HREF_LOCALE.CURRENT,
            },
          },
          {
            id: STUDENT_BTN_ID.CLICK_MENU_OVERSEAS_RESIDENTS,
            label: '해외 거주자',
            href: {
              url: urls.student.landing.case.customer.liveAbroad,
              type: MENU_HREF_TYPE.WITHIN,
              locale: MENU_HREF_LOCALE.CURRENT,
            },
          },
          {
            id: STUDENT_BTN_ID.CLICK_MENU_INTERNATIONAL_STUDENTS,
            label: '유학생',
            href: {
              url: urls.student.landing.case.customer.studyAbroad,
              type: MENU_HREF_TYPE.WITHIN,
              locale: MENU_HREF_LOCALE.CURRENT,
            },
          },
          {
            id: STUDENT_BTN_ID.CLICK_MENU_BEGINNER_INTERMEDIATE,
            label: '영어 초중급자',
            href: {
              url: urls.student.landing.case.customer.beginner,
              type: MENU_HREF_TYPE.WITHIN,
              locale: MENU_HREF_LOCALE.CURRENT,
            },
          },
        ],
      },
      {
        subMenuSectionTitle: 'BY NEEDS',
        subMenuList: [
          {
            id: STUDENT_BTN_ID.CLICK_MENU_BUSINESS_ENGLISH,
            label: '비지니스 영어',
            href: {
              url: urls.student.landing.case.purpose.business,
              type: MENU_HREF_TYPE.WITHIN,
              locale: MENU_HREF_LOCALE.CURRENT,
            },
          },
          {
            id: STUDENT_BTN_ID.CLICK_MENU_INTERVIEW_PREP,
            label: '인터뷰 준비',
            href: {
              url: urls.student.landing.case.purpose.interview,
              type: MENU_HREF_TYPE.WITHIN,
              locale: MENU_HREF_LOCALE.CURRENT,
            },
          },
          {
            id: STUDENT_BTN_ID.CLICK_MENU_RESUME_ESSAY,
            label: '이메일/에세이 교정',
            href: {
              url: urls.student.landing.case.purpose.correction,
              type: MENU_HREF_TYPE.WITHIN,
              locale: MENU_HREF_LOCALE.CURRENT,
            },
          },
        ],
      },
    ],
  },
  {
    id: STUDENT_BTN_ID.CLICK_MENU_PRICING,
    label: 'Pricing',
    isEvent: false,
    href: {
      url: urls.student.landing.pricing,
      type: MENU_HREF_TYPE.WITHIN,
      locale: MENU_HREF_LOCALE.CURRENT,
    },
    subMenu: null,
  },
  {
    id: STUDENT_BTN_ID.CLICK_MENU_BUSINESS,
    label: 'Business',
    isEvent: false,
    href: null,
    subMenu: [
      {
        subMenuSectionTitle: null,
        subMenuList: [
          {
            id: STUDENT_BTN_ID.CLICK_MENU_BUSINESS_VOUCHER,
            label: '수출 바우처',
            href: {
              url: urls.student.landing.voucher,
              type: MENU_HREF_TYPE.WITHIN,
              locale: MENU_HREF_LOCALE.CURRENT,
            },
          },
          {
            id: STUDENT_BTN_ID.CLICK_MENU_BUSINESS_B2B,
            label: '제휴문의',
            href: {
              url: urls.b2b.index,
              type: MENU_HREF_TYPE.WITHIN,
              locale: MENU_HREF_LOCALE.CURRENT,
            },
          },
        ],
      },
    ],
  },
  {
    id: STUDENT_BTN_ID.CLICK_MENU_HELP,
    label: 'Help Center',
    isEvent: false,
    href: {
      url: urls.student.landing.faq,
      type: MENU_HREF_TYPE.WITHIN,
      locale: MENU_HREF_LOCALE.CURRENT,
    },
    subMenu: null,
  },
  {
    id: STUDENT_BTN_ID.CLICK_MENU_CHANGE_LANG,
    label: 'Change Language',
    isEvent: false,
    href: null,
    subMenu: [
      {
        subMenuSectionTitle: null,
        subMenuList: [
          {
            id: STUDENT_BTN_ID.CLICK_MENU_CHANGE_LANG_EN,
            label: 'English',
            href: {
              url: urls.oneOnOne.index,
              type: MENU_HREF_TYPE.LOCALE_CHANGE,
              locale: MENU_HREF_LOCALE.EN,
            },
          },
          {
            id: STUDENT_BTN_ID.CLICK_MENU_CHANGE_LANG_KO,
            label: '한국어',
            href: {
              url: urls.oneOnOne.index,
              type: MENU_HREF_TYPE.LOCALE_CHANGE,
              locale: MENU_HREF_LOCALE.KO,
            },
          },
          {
            id: STUDENT_BTN_ID.CLICK_MENU_CHANGE_LANG_JA,
            label: '日本語',
            href: {
              url: urls.oneOnOne.index,
              type: MENU_HREF_TYPE.LOCALE_CHANGE,
              locale: MENU_HREF_LOCALE.JA,
            },
          },
          {
            id: STUDENT_BTN_ID.CLICK_MENU_CHANGE_LANG_ZH_CHS,
            label: '中文(简体)',
            href: {
              url: urls.oneOnOne.index,
              type: MENU_HREF_TYPE.LOCALE_CHANGE,
              locale: MENU_HREF_LOCALE.ZH_CHS,
            },
          },
          {
            id: STUDENT_BTN_ID.CLICK_MENU_CHANGE_LANG_ZH_CHT,
            label: '中文(繁體)',
            href: {
              url: urls.oneOnOne.index,
              type: MENU_HREF_TYPE.LOCALE_CHANGE,
              locale: MENU_HREF_LOCALE.ZH_CHT,
            },
          },
          {
            id: STUDENT_BTN_ID.CLICK_MENU_CHANGE_LANG_VI,
            label: 'Tiếng Việt',
            href: {
              url: urls.oneOnOne.index,
              type: MENU_HREF_TYPE.LOCALE_CHANGE,
              locale: MENU_HREF_LOCALE.VI,
            },
          },
        ],
      },
    ],
  },
]

export const sendNavigationMenuClickEvent = (
  btnId: STUDENT_BTN_ID,
  btnName: string,
  currentUser: CurrentUser,
  router: CustomRouter,
  variation: string | null
) => {
  sendGTMCustomClickEvent(
    GTM_CLICK_EVENT.CLICK_LANDING_BUTTON,
    btnId,
    btnName,
    getEventUserType(currentUser),
    `${router.asPath.substring(1).split('/').join('-')}${variation ? ` - ${variation}` : ''}`,
    router.asPath,
    {
      category: 'menu',
    }
  )
}

export const sendBottomNavigationClickEvent = (
  btnId: STUDENT_BTN_ID,
  btnName: string,
  currentUser: CurrentUser,
  router,
  variation: string | null
) => {
  sendGTMCustomClickEvent(
    GTM_CLICK_EVENT.CLICK_LANDING_BUTTON,
    btnId,
    btnName,
    getEventUserType(currentUser),
    `${router.asPath.substring(1).split('/').join('-')}${variation ? ` - ${variation}` : ''}`,
    router.asPath,
    {
      category: 'bottom-navigation',
    }
  )
}

export const sendBottomNavigationClickEventforTrial = (btnName: string, custom_page_title: string, login: boolean) => {
  if (custom_page_title === 'portal_welcome') {
    custom_page_title = 'trial_welcome'
  }
  sendGTMEvent(STUDENT_BTN_ID.CLICK_LANDING_BOTTOM_MENU, {
    custom_page_title: custom_page_title,
    btn_name: btnName,
    device_type: 'mobile_web',
    login: login,
  })
}
